/** Footer social links — SVG files in /public/icons/social/ must use fill="#fff" (not currentColor). */
export const FOOTER_SOCIAL_LINKS = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/adidas",
    iconSrc: "/icons/social/facebook.svg",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/adidas",
    iconSrc: "/icons/social/instagram.svg",
  },
  {
    name: "X",
    href: "https://x.com/adidas",
    iconSrc: "/icons/social/x.svg",
  },
  {
    name: "Pinterest",
    href: "https://www.pinterest.com/adidas",
    iconSrc: "/icons/social/pinterest.svg",
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@adidas",
    iconSrc: "/icons/social/tiktok.svg",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/adidas",
    iconSrc: "/icons/social/youtube.svg",
  },
] as const
